<template>
  <div class="score">
    <Loading v-if="loading" />
    <div class="bgc top_div">
      <div class="title">
        <div class="sort_son_title">
          {{ itemTitle }}
        </div>
        <!-- tabs切换 -->
        <div v-if="id == 'chartC' && query.seId > 0" class="wrap-tab">
          <a-tabs
            :active-key="tabActive"
            class="setmodel-tab"
            @change="changeTab"
          >
            <a-tab-pane
              v-for="item in selectList"
              :key="item.sType"
              :tab="item.name"
            />
          </a-tabs>
        </div>
        <div class="right_div">
          <a-button
            v-if="data && data.length"
            class="btn"
            type="primary"
            ghost
            @click="importTo"
          >
            {{ $t('exam.downbtn') + itemTitle + $t('exam.biao') }}
          </a-button>
        </div>
      </div>
      <div v-if="id == 'chartC' && query.seId > 0">
        {{ exp[tabActive] }}
      </div>
      <div v-if="data.length" class="echarts">
        <div :id="id" class="echarts_list"></div>
      </div>
      <NotData v-show="!data.length && !loading" />
    </div>
    <div v-if="data && data.length" class="bgc table_div">
      <Table
        :columns="columns"
        :pagination="false"
        :data="data"
        :custom-row="customRow"
      />
    </div>
  </div>
</template>

<script>
  import axios, { getCookie, isUnion } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/sortTable.vue'
  import * as echarts from 'echarts'
  import Loading from '@comp/loading'
  import { getCol } from '@utils/unite.js'

  export default {
    name: 'ClassTotal',
    components: {
      Table,
      Loading
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      itemTitle: {
        type: String,
        default: ''
      },
      cache: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        columns: [],
        columns1: getCol(`getfourpointlist${isUnion()}`) || [
          {
            title: this.$t('exam.classGroup'),
            dataIndex: 'classType',
            key: 'classType',
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('exam.className'),
            dataIndex: 'className',
            key: 'className',
            width: 100,
            ellipsis: true
          },
          {
            title: this.$t('exam.studentNum'),
            dataIndex: 'studentNum',
            key: 'studentNum',
            width: 100,
            ellipsis: true
          }
        ],
        data: [],
        // chartList: [],
        arrMinScore: [],
        arrMaxScore: [],
        splitNum: 7,
        barRadius: [6, 6, 0, 0],
        titles: [],
        tabActive: 0,
        selectList: [],
        query: this.$route.query,
        colors: [
          'rgba(60, 100, 239, 1)',
          'rgba(79, 115, 240, 1)',
          'rgba(97, 130, 242, 1)',
          'rgba(118, 146, 244, 1)',
          '#69D4AA',
          '#FFD995',
          '#FF8484',
          '#5f8eec'
        ],
        classColors: [
          'rgba(251, 146, 33, 1)',
          'rgba(251, 146, 33, .8)',
          'rgba(251, 146, 33, .6)',
          'rgba(251, 146, 33, .4)'
        ],
        fourthRateName: [],
        scoreline: [],
        exp: [
          this.$t('exam.sing.exp[0]'),
          this.$t('exam.sing.exp[1]'),
          this.$t('exam.sing.exp[2]'),
          this.$t('exam.sing.exp[3]')
        ],
        charts: null,
        cacheData: false //是否缓存数据
      }
    },
    watch: {
      $route: {
        handler(newData, oldData) {
          var groupStatus = newData.query.dId === oldData.query.dId
          var subjectStatus =
            newData.query.subjectId === oldData.query.subjectId
          if (
            groupStatus &&
            subjectStatus &&
            newData.query.classId !== oldData.query.classId
          ) {
            this.cacheData = true
          }
        }
      }
    },
    mounted() {
      if (this.$route.query.examIsActive == 0) {
        this.columns1.push({
          title:
            this.$route.query.seId == 0
              ? this.$t('exam.ClassTeacher')
              : this.$t('exam.teacher'),
          dataIndex: 'teacherName',
          key: 'teacherName',
          width: 120
        })
      }
      this.getTable()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      //
      resizeChart() {
        if (this.charts) this.charts.resize()
      },
      customRow(record) {
        let className =
          this.$route.query.classId * 1 &&
          record.classId == this.$route.query.classId
            ? 'current'
            : ''
        return className
      },
      changeTab(key) {
        this.tabActive = key
        this.getData()
      },
      beforeEchart(data, yTitle, params = {}) {
        let {
          split = true,
          splitNum = this.splitNum,
          abs = false,
          labelFc = null
        } = params
        let top
        if (data.legend && data.legend.data) {
          let baseNum = Math.ceil(data.legend.data.length / 4)
          top = baseNum * 30 + 24
        }
        //echarts距离处理
        data.grid = {
          top: data.legend ? top : 24,
          bottom: 28,
          left: '4%',
          right: '4%'
        }
        //x轴处理
        if (Array.isArray(data.xAxis)) {
          data.xAxis.forEach(item => {
            xDataDispose(item)
          })
        } else {
          xDataDispose(data.xAxis)
        }
        //x轴数据处理
        function xDataDispose(xData) {
          if (!xData.axisLabel) xData.axisLabel = {}
          xData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 14
          }
          xData.axisTick = {
            show: false
          }
          !xData.offset && (xData.offset = 4)
          if (!xData.axisLine) {
            xData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          }
        }

        //Y轴处理
        if (!data.yAxis) data.yAxis = {}
        if (Array.isArray(data.yAxis)) {
          data.yAxis.forEach(item => {
            yDataDispose(item)
          })
        } else {
          yDataDispose(data.yAxis)
        }
        //y轴数据处理
        function yDataDispose(yData) {
          if (!yData.splitLine) {
            yData.splitLine = {
              show: false
            }
          }

          if (!yData.axisLabel) yData.axisLabel = {}
          yData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 12
          }
          if (!yData.axisLine) {
            yData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              },
              itemStyle: {
                color: '#666666'
              }
            }
          }
          if (!yData.splitArea) {
            yData.splitArea = {
              show: true,
              areaStyle: {
                color: ['#A78BFA', '#fff'],
                opacity: 0.04
              }
            }
          }
        }

        //分割处理

        if (split) {
          let max = yTitle
          if (Array.isArray(yTitle)) {
            max = Math.max(...yTitle)
          }
          if (Array.isArray(data.yAxis)) {
            data.yAxis.forEach(item => {
              labelDispose(item, max)
            })
          } else {
            let splitVal = max / splitNum
            if (abs) splitVal = splitVal * 2
            data.yAxis.max = max
            data.yAxis.interval = splitVal
            labelDispose(data.yAxis, max)
          }
        }
        function labelDispose(label, max) {
          //label处理
          label.axisLabel.formatter = value => {
            var texts = []
            let nums = Math.floor(max / splitNum)
            texts.push(+value.toFixed(nums ? 0 : 1) + (labelFc && labelFc()))
            return texts
          }
        }
      },
      //图表滚动条
      cScroll(data, xTitle, num) {
        //如果超过num个则显示滚动条
        if (xTitle.length >= num) {
          let endVal = num === 1 ? 5 : +(100 * (num / xTitle.length)).toFixed(2)
          data.grid.bottom = 64
          data.dataZoom = [
            {
              start: 0, //默认为0
              end: endVal, //默认为100
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              handleIcon: `M 100, 100
                                  m -75, 0
                                  a 75,75 0 1,0 150,0
                                  a 75,75 0 1,0 -150,0`,
              handleSize: '85%',
              handleStyle: {
                color: '#ddeeff',
                borderWidth: 0
              },
              moveHandleSize: 0, //移动手柄尺寸高度
              height: 8, //组件高度
              left: 40, //左边的距离
              right: 40, //右边的距离
              bottom: 14, //底部的距离
              fillerColor: '#ddeeff', //线条颜色
              borderColor: 'transparent', //线条边框颜色
              backgroundColor: '#F8F8F8', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
              brushSelect: false //关闭十字架选中
            }
          ]
        }
      },
      renderChart(legendData, seriesData, maxScore) {
        this.$nextTick(() => {
          const _this = this
          let element = document.getElementById(this.id)
          if (!element) return
          this.charts = echarts.init(element)
          let option = {
            color: _this.colors,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                shadowStyle: {
                  shadowColor: 'rgba(34, 87, 188, 1)'
                }
              },
              // enterable: true, //鼠标可进入提示框
              borderWidth: 0, //设置自定义边框宽度
              backgroundColor: 'none', //设置自定义背景
              extraCssText:
                //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
                'backdrop-filter: blur(10px)',
              formatter: params => {
                let stuNum = _this.data.find(
                  item => item.className == params[0].name
                ).studentNum
                let relVal = `<div style='font-weight: 500;line-height: 20px;color: @text-color-secondary;'>${
                  params[0].name
                }</div>
                <div${this.$t('exam.studentNum')}：${stuNum}人</div>`
                for (var i = 0, l = params.length; i < l; i++) {
                  let symbolStr =
                    params[i].seriesType == 'bar' ? this.$t('exam.ren') : '%'

                  relVal += `<div class="toolTip">${params[i].marker}${params[i].seriesName}：${params[i].value}${symbolStr}</div>`
                }

                return relVal
              }
            },
            legend: {
              data: legendData
            },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              data: this.titles
            },
            yAxis: [
              {
                type: 'value',
                scale: true,
                name: this.$t('exam.rateTitle'),
                nameTextStyle: {
                  color: '#333'
                },
                max: 100,
                min: 0,
                maxInterval: +(100 / this.splitNum).toFixed(2),
                boundaryGap: [0.2, 0.2],
                axisLabel: {
                  formatter: value => {
                    var texts = []
                    let nums = Math.floor(100 / this.splitNum)
                    texts.push(+value.toFixed(nums ? 0 : 1) + '%')
                    return texts
                  }
                }
              },
              {
                type: 'value',
                scale: true,
                name: this.$t('exam.peopleNum'),
                nameTextStyle: {
                  color: '#333'
                },
                max: maxScore,
                min: 0,
                maxInterval: Math.ceil(maxScore / this.splitNum),
                boundaryGap: [0.2, 0.2],
                axisLabel: {
                  formatter: value => {
                    var texts = []
                    let nums = Math.floor(maxScore / this.splitNum)
                    texts.push(+value.toFixed(nums ? 0 : 1))
                    return texts
                  }
                }
              }
            ],
            series: seriesData
          }
          this.beforeEchart(option, 100, { split: false })
          this.cScroll(option, this.titles, 10)
          this.charts.setOption(option)
        })
      },
      getTable() {
        this.loading = true
        let {
          meId,
          dId,
          seId,
          classId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let urlObj = {
          chartJ: [
            'getfourpointlist',
            'getfourpointlistUnion',
            'getfourpointlistSchoolUnion'
          ],
          chartC: [
            'getscorelineanalysis',
            'getscorelineanalysisUnion',
            'getscorelineanalysisSchoolUnion'
          ]
        }
        //获取
        let params = {
          meId,
          classId,
          seId,
          dId,
          campusId
        }
        let url = urlObj[this.id][examIsActive]

        axios({
          url,
          params,
          loading: false,
          getCache: this.cache,
          cacheData: this.cacheData
        })
          .then(res => {
            this.loading = false
            this.fourthRateName = res.data.fourthRateName
            let columns = []
            const titleText = ['fist', 'second', 'third', 'fourth']
            this.fourthRateName.forEach((item, index) => {
              if (this.id == 'chartJ') {
                //四率
                columns.push({
                  title: item,
                  children: [
                    {
                      title: 'N',
                      dataIndex: `${titleText[index]}Number`,
                      key: `${titleText[index]}Number`,
                      align: 'center',
                      width: 100
                    },
                    {
                      title: '%',
                      dataIndex: `${titleText[index]}Rate`,
                      key: `${titleText[index]}Rate`,
                      align: 'center',
                      width: 100
                    },
                    {
                      title: this.$t('exam.ranking'),
                      dataIndex: `${titleText[index]}RankNumber`,
                      key: `${titleText[index]}RankNumber`,
                      align: 'center',
                      width: 100
                    }
                  ]
                })
              }
              if (this.id == 'chartC') {
                //上线
                columns.push({
                  title: item,
                  children: [
                    {
                      title: 'N',
                      dataIndex: `${titleText[index]}Number`,
                      key: `${titleText[index]}Number`,
                      align: 'center',
                      width: 100
                    },
                    {
                      title: '%',
                      dataIndex: `${titleText[index]}Rate`,
                      key: `${titleText[index]}Rate`,
                      align: 'center',
                      customRender(text, row) {
                        console.log(text, row)

                        return 'chris'
                      },
                      width: 100
                    },
                    {
                      title: this.$t('exam.ranking'),
                      dataIndex: `${titleText[index]}RankNumber`,
                      key: `${titleText[index]}RankNumber`,
                      align: 'center',

                      width: 100
                    }
                  ]
                })
              }
            })
            this.columns = [...this.columns1, ...columns]

            if (this.id == 'chartJ') {
              //四率
              this.data = res.data.classInfoList
              if (this.data.length) {
                this.chartData(this.data)
              }
            }
            if (this.id == 'chartC') {
              //上线
              this.selectList = res.data.lists
              this.scoreline = res.data.lists
              this.getData()
              return
            }
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      getData() {
        let { examIsActive = 1 } = this.$route.query
        this.columns = []
        let chartCtitle = [...this.$t('exam.chartCtitle')]
        let chartCclass = []
        let columns = []
        const titleText = ['fist', 'second', 'third', 'fourth']
        this.fourthRateName.forEach((item, index) => {
          //上线
          if (this.tabActive > 0) {
            chartCclass = [
              {
                title: this.$t('exam.twoN'),
                dataIndex: `${titleText[index]}DoubleNumber`,
                key: `${titleText[index]}DoubleNumber`,
                align: 'center',
                width: 100
              },
              {
                title: chartCtitle[this.tabActive],
                dataIndex: `${titleText[index]}DoubleRate`,
                key: `${titleText[index]}DoubleRate`,
                align: 'center',
                width: 100
              },
              {
                title: this.$t('exam.ranking'),
                dataIndex: `${titleText[index]}DoubleRankNumber`,
                key: `${titleText[index]}DoubleRankNumber`,
                align: 'center',
                width: 100
              }
            ]
          }
          columns.push({
            title: item,
            children: [
              {
                title: 'N',
                dataIndex: `${titleText[index]}Number`,
                key: `${titleText[index]}Number`,
                align: 'center',
                width: 100
              },
              {
                title: '%',
                dataIndex: `${titleText[index]}Rate`,
                key: `${titleText[index]}Rate`,
                align: 'center',
                customRender(t, r) {
                  let str = t
                  if (+examIsActive == 1) {
                    str = `${t} (${r[titleText[index] + 'MaxScore']} 分/${
                      r[titleText[index] + 'Score']
                    } 分)`
                  }
                  return str
                },
                width: 100
              },
              {
                title: this.$t('exam.ranking'),
                dataIndex: `${titleText[index]}RankNumber`,
                key: `${titleText[index]}RankNumber`,
                align: 'center',
                width: 100
              },
              ...chartCclass
            ]
          })
        })
        this.columns = [...this.columns1, ...columns]

        console.log(this.columns)

        this.data =
          this.scoreline.filter(item => item.sType == this.tabActive)[0]
            .classInfoList || []
        if (this.data.length) {
          this.chartData(this.data)
        }
      },
      chartData(data) {
        const _this = this
        let legendData = []
        let seriesData = []
        let arr1 = []
        let arr2 = []
        let sreArr1 = []
        let sreArr2 = []
        let maxArr = []

        const titleText = ['fist', 'second', 'third', 'fourth']
        let xData = data.filter(item => item.classId)
        this.titles = xData.map(item => item.className)
        const currentClass = xData.filter(
          ele => ele.classId == this.query.classId
        )
        let className = currentClass.length
          ? currentClass[0].className
          : this.$t('exam.grade')
        let titArr = [...this.$t('exam.titArr')]
        let nameStr =
          _this.id == 'chartJ'
            ? this.$t('exam.peopleNum')
            : titArr[_this.tabActive].barTitle

        this.fourthRateName.forEach(item => {
          arr1.push({
            name: `${item}${nameStr}`
          })
          arr2.push({
            name: `${item}${
              _this.id == 'chartJ' ? '' : titArr[_this.tabActive].linetitle
            }`
          })
          sreArr2.push({
            name: `${item}${
              _this.id == 'chartJ' ? '' : titArr[_this.tabActive].linetitle
            }`,
            type: 'line',
            // showSymbol: false,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2
                }
              }
            },
            // emphasis: {
            //   focus: 'series'
            // },
            smooth: true,
            data: []
          })
          sreArr1.push({
            name: `${item}${nameStr}`,
            type: 'bar',
            barMaxWidth: 50,
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: params => {
                  let color = _this.colors[params.seriesIndex]
                  if (params.name == className) {
                    color = _this.classColors[params.seriesIndex]
                  }
                  return color
                },
                barBorderRadius: this.barRadius
              }
            },
            data: []
          })
        })
        sreArr1.forEach((item, index) => {
          this.data.forEach(cls => {
            item.data.push(
              cls[
                `${titleText[index]}${
                  _this.tabActive ? 'DoubleNumber' : 'Number'
                }`
              ]
            )
          })

          maxArr.push(Math.max(...item.data))
        })
        sreArr2.forEach((item, index) => {
          xData.forEach(cls => {
            item.data.push(
              cls[
                `${titleText[index]}${_this.tabActive ? 'DoubleRate' : 'Rate'}`
              ]
            )
          })
        })

        legendData = [...arr1, ...arr2]
        seriesData = [...sreArr1, ...sreArr2]
        let maxScore = Math.max(...maxArr)

        this.renderChart(legendData, seriesData, maxScore)
      },
      importTo() {
        let {
          meId,
          seId,
          dId,
          classId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let urlObj = {
          chartJ: [
            'exportfourpoint',
            'exportfourpointUnion',
            'exportfourpointSchoolUnion'
          ],
          chartC: [
            'exportscorelineanalysis',
            'exportscorelineanalysisUnion',
            'exportscorelineanalysisSchoolUnion'
          ]
        }
        let queryParams = {
          meId,
          seId,
          dId,
          classId,
          campusId
        }
        let queryList = []
        for (let q in queryParams) {
          if (queryParams[q] !== undefined) {
            queryList.push(`${q}=${queryParams[q]}`)
          }
        }
        let union = urlObj[this.id][examIsActive]
        let api = ApiXy.defaulteApi.path[union]
        let url =
          `${ApiXy.defaulteApi.host}${api}?` +
          queryList.join('&') +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')
        window.open(url, '_blank', '')
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 4px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  /deep/.current {
    background: rgba(60, 100, 239, 0.2);
    td {
      background: none !important;
    }
  }
  /deep/.ant-tabs-ink-bar {
    display: none !important;
  }
  .score {
    height: 100%;
    .left {
      float: left;
    }
    .right {
      float: right;
    }
    // Tab切换
    .wrap-tab {
      height: 30px;
      overflow: hidden;
      flex: 1;
      .setmodel-tab {
        /deep/.ant-tabs-bar {
          border: none;
          .ant-tabs-tab {
            height: 30px;
            line-height: 30px;
            min-width: 88px;
            border-radius: 15px;
            padding: 0 16px;
            margin-right: 8px;
            font-weight: 400;
            color: #4e5969;
            font-size: @font-size-base;
          }
          .ant-tabs-tab-active {
            border: none;
            background: #f2f3f8;
            color: @primary-color;
          }
        }
      }
    }

    .top_div {
      min-height: 400px;
      margin-bottom: 12px;
    }
    .echarts {
      .echarts_list {
        width: 100%;
        min-height: 400px;
      }
    }
    .not_data_box {
      padding: 20px 0;
    }
    // .table_div {
    //   margin-top: 12px;
    // }
  }
</style>
